<script setup lang="ts">
import {
	CREDIT_INPUT_LIMITS,
	FINANCING_ANNUAL_RATE,
	formatBrl,
	formatPercent,
	formatPlainInput,
	useCreditSimulator
} from '~/composables/credit';

import CreditSimulatorAmountField from './CreditSimulatorAmountField.vue';
import CreditSimulatorSummary from './CreditSimulatorSummary.vue';

const simulator = useCreditSimulator();
const inputs = computed(() => simulator.state.value.inputs);
const result = simulator.financing;

const summaryItems = computed(() => [
	{
		label: 'Última parcela (SAC)',
		value: formatBrl(result.value.sacLastInstallment)
	},
	{
		label: 'Parcela fixa (Price)',
		value: formatBrl(result.value.priceInstallment)
	},
	{ label: 'Valor financiado', value: formatBrl(result.value.financedAmount) },
	{
		label: 'Renda familiar sugerida',
		value: formatBrl(result.value.suggestedIncome)
	}
]);
</script>

<template>
	<div class="flex flex-col gap-4.5">
		<CreditSimulatorAmountField
			label="Valor do imóvel"
			range-id="f-valor"
			text-id="f-valor-n"
			text-label="Valor do imóvel em reais"
			:amount-value="inputs.financingValue"
			:range-value="inputs.financingValue"
			v-bind="CREDIT_INPUT_LIMITS.financingValue"
			@amount="simulator.setInput('financingValue', $event)"
			@commit="simulator.commitInput('financingValue')"
			@slide="simulator.setInput('financingValue', $event)"
		/>
		<CreditSimulatorAmountField
			:label="`Entrada (${Math.round(inputs.financingDownPaymentPercent)}%)`"
			range-id="f-ent"
			text-id="f-ent-n"
			text-label="Valor da entrada em reais"
			:amount-value="result.downPayment"
			:range-value="inputs.financingDownPaymentPercent"
			v-bind="CREDIT_INPUT_LIMITS.financingDownPaymentPercent"
			@amount="
				simulator.setPercentFromAmount(
					'financingDownPaymentPercent',
					'financingValue',
					$event
				)
			"
			@commit="simulator.commitInput('financingDownPaymentPercent')"
			@slide="simulator.setInput('financingDownPaymentPercent', $event)"
		/>
		<CreditSimulatorAmountField
			label="Prazo"
			range-id="f-prazo"
			text-id="f-prazo-n"
			text-label="Prazo em anos"
			unit="anos"
			:text-value="formatPlainInput(inputs.financingYears)"
			:range-value="inputs.financingYears"
			v-bind="CREDIT_INPUT_LIMITS.financingYears"
			@type="simulator.typeInput('financingYears', $event)"
			@commit="simulator.commitInput('financingYears')"
			@slide="simulator.setInput('financingYears', $event)"
		/>
		<CreditSimulatorSummary
			:headline="{
				label: '1ª parcela estimada (SAC)',
				value: formatBrl(result.sacFirstInstallment)
			}"
			:items="summaryItems"
		/>
		<div class="text-[12px] text-[#8A8A8A]">
			Taxa a partir de {{ formatPercent(FINANCING_ANNUAL_RATE * 100, 2) }} a.a.
			+ TR. Não inclui seguros, TR e tarifas.
		</div>
	</div>
</template>
